// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"530":"34453980","678":"c0107d84","787":"0f994b38"}[chunkId] + ".chunk.js";
};